import { type BalanceHistoryItem, HistoryFiltersType } from "@/types/balances"

import type { Option } from "@/ui/components/Dropdown"

export type FormErrors = {
  contractor: boolean
  owner: boolean
}

export const getLabelForTypeValue = (value: string): string => {
  switch (value) {
    case HistoryFiltersType.Rep:
      return "Replenishment"
    case HistoryFiltersType.Xch:
      return "Exchange currency"
    case HistoryFiltersType.Trsf:
      return "Internation transfer money"
    case HistoryFiltersType.Cmm:
      return "Bank comission"
    case HistoryFiltersType.Exps:
      return "Company expenses"
    case HistoryFiltersType.Rfnd:
      return "Refund"
    case HistoryFiltersType.Dep:
      return "Interest rates on deposits"
    default:
      return ""
  }
}

export const typeFilterOptions: Option[] = [
  {
    value: HistoryFiltersType.Rep,
    label: "Replenishment"
  },
  {
    value: HistoryFiltersType.Xch,
    label: "Exchange currency"
  },
  {
    value: HistoryFiltersType.Trsf,
    label: "Internation transfer money"
  },
  {
    value: HistoryFiltersType.Cmm,
    label: "Bank comission"
  },
  {
    value: HistoryFiltersType.Exps,
    label: "Company expenses"
  },
  {
    value: HistoryFiltersType.Rfnd,
    label: "Refund"
  },
  {
    value: HistoryFiltersType.Dep,
    label: "Interest rates on deposits"
  }
]

export const validateData = (data: Partial<BalanceHistoryItem>): FormErrors => {
  const newErrors: FormErrors = {
    contractor: false,
    owner: false
  }

  if (!data.contractor_value) {
    newErrors.contractor = true
  }

  if (!data.owner_value) {
    newErrors.owner = true
  }

  return newErrors
}
